/*
 * @Author: your name
 * @Date: 2020-11-23 10:05:08
 * @LastEditTime: 2021-03-08 14:47:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import websocket from './websocket'
import crossParent from './crossParent'
import program from './programEditing'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    websocket,
    crossParent,
    program
  }
})
